// "Engaged clicks" vs "unsubscribe clicks" split display.
//
// Brevo's click tracking rewrites every <a href> in the email body —
// INCLUDING the unsubscribe footer link. So a recipient who clicks
// Unsubscribe in the body counts as both a click AND an unsubscribe.
// Showing raw click counts overstates real engagement.
//
//   red  = min(clicked, unsubscribed)   (capped — can't have more
//                                         unsub-clicks than total clicks;
//                                         covers the Gmail one-click case
//                                         where unsub fires without click)
//   green = clicked - red               (engaged, real-link clicks)
//
// Display: "8 - 2"  with green / red coloring.
// Tooltip: explains the math so users aren't confused.

export function ClickSplit({ clicked, unsubscribed, compact }: {
  clicked: number; unsubscribed: number; compact?: boolean;
}) {
  const red = Math.min(clicked, unsubscribed);
  const green = clicked - red;
  const tip = `${green} engaged click${green === 1 ? "" : "s"} (real link interest)\n${red} unsubscribe click${red === 1 ? "" : "s"} (link tracking counts the unsub footer too, but the recipient was leaving)\n\nTotal click events: ${clicked}`;

  if (clicked === 0) {
    return <span className="text-gray-400" title="No clicks yet">0</span>;
  }

  return (
    <span title={tip} className={compact ? "" : "tabular-nums"}>
      <span className="text-emerald-600 font-medium">{green}</span>
      <span className="text-gray-400 mx-0.5">-</span>
      <span className="text-red-600 font-medium">{red}</span>
    </span>
  );
}
